import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import owner from '../images/ssss.jpeg'; // Adjust path as needed

const AboutOwner = () => {
    return (
        <>
            {/* About Sanjeev Section - Premium Design with Dark/Light Mode */}
            <section className="about-section">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Image Column - Left side on desktop */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12 mb-5 mb-lg-0">
                            <div className="inner-column">
                                <div className="image-wrapper">
                                    <div className="image-card">
                                        <figure className="owner-image">
                                            <img src={owner} alt="Sanjeev Kumar - Founder" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <span className="experience-badge">20+ Years Excellence</span>
                                                </div>
                                            </div>
                                        </figure>
                                    </div>
                                    <div className="image-btn-box">
                                        <Link to="/SanjeevPeofile" className="btn-meet">
                                            <span>Meet Sanjeev</span>
                                            <svg className="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                                <polyline points="12 5 19 12 12 19"></polyline>
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content Column - Right side on desktop */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12">
                            <div className="content-inner">
                                <div className="section-badge">Our Founder</div>
                                <h1 className="founder-name">Sanjeev Kumar <span className="highlight"></span></h1>
                                
                                <div className="tagline">
                                    <span className="tagline-icon">✦</span>
                                    Insurance Expert & Visionary Leader
                                </div>

                                {/* Social Media Icons */}
                                <div className="social-links">
                                    <a href="https://www.facebook.com/sanjeev.kumar.44386/" target="_blank" rel="noopener noreferrer" className="social-link fb">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a href="https://www.instagram.com/agency_bazaar?igsh=Z3hwbHJyaXBzd2ho" target="_blank" rel="noopener noreferrer" className="social-link ig">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/sanjeev-kumar5/" target="_blank" rel="noopener noreferrer" className="social-link li">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                    <a href="https://www.youtube.com/@PowerTalkwithSanjeev" target="_blank" rel="noopener noreferrer" className="social-link yt">
                                        <i className="fab fa-youtube"></i>
                                    </a>
                                </div>

                                <div className="description-text">
                                    <p>Renowned for his expertise in <strong>Health, Life & General insurance</strong>, he has consistently guided individuals and families toward making informed and strategic financial protection decisions.</p>
                                    <p>Since establishing <strong>Agency Bazaar in 2020</strong>, he has been instrumental in building a platform that redefines the insurance experience through transparency, reliability, and personalized solutions.</p>
                                    <p>Driven by a clear vision, his mission is to transform insurance into a seamless, accessible, and highly trusted service for every customer.</p>
                                </div>

                                {/* Stats Cards */}
                                <div className="stats-grid">
                                    <div className="stat-card">
                                        <div className="stat-number">20<span>+</span></div>
                                        <div className="stat-label">Years of Excellence</div>
                                    </div>
                                    <div className="stat-card">
                                        <div className="stat-number">2020</div>
                                        <div className="stat-label">Founded Agency Bazaar</div>
                                    </div>
                                </div>

                                {/* Expertise Tags */}
                                <div className="expertise-tags">
                                    <span className="tag">🏥 Health Insurance</span>
                                    <span className="tag">💼 Life Insurance</span>
                                    <span className="tag">🛡️ General Insurance</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Font Awesome */}
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

            <style jsx>{`
                /* ======================================== */
                /* DARK/LIGHT MODE VARIABLES */
                /* ======================================== */
                
                :root {
                    /* Light Mode Colors */
                    --about-bg: linear-gradient(135deg, #faf9ff 0%, #f0f2ff 100%);
                    --about-bg-overlay: rgba(255,34,34,0.03);
                    --founder-name-color: #1a1a2e;
                    --tagline-bg: #f0f2ff;
                    --tagline-color: #4a4a6a;
                    --description-text-color: #555;
                    --stat-card-bg: #ffffff;
                    --stat-card-shadow: rgba(0,0,0,0.05);
                    --stat-card-border: rgba(255,34,34,0.1);
                    --stat-label-color: #666;
                    --btn-meet-bg: #ffffff;
                    --btn-meet-color: #ff2222;
                    --btn-meet-border: rgba(255,34,34,0.2);
                }
                
                [data-theme="dark"] {
                    /* Dark Mode Colors */
                    --about-bg: linear-gradient(135deg, #0a0a1a 0%, #1a1a2e 100%);
                    --about-bg-overlay: rgba(255,68,68,0.05);
                    --founder-name-color: #ffffff;
                    --tagline-bg: rgba(255,34,34,0.1);
                    --tagline-color: #ff8888;
                    --description-text-color: #c0c0c0;
                    --stat-card-bg: #1e1e2e;
                    --stat-card-shadow: rgba(0,0,0,0.3);
                    --stat-card-border: rgba(255,68,68,0.2);
                    --stat-label-color: #a0a0a0;
                    --btn-meet-bg: #1e1e2e;
                    --btn-meet-color: #ff4444;
                    --btn-meet-border: rgba(255,68,68,0.3);
                }

                /* Premium Styles */
                .about-section {
                    position: relative;
                    padding: 100px 0;
                    background: var(--about-bg);
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .about-section::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    right: -20%;
                    width: 80%;
                    height: 150%;
                    background: radial-gradient(circle, var(--about-bg-overlay) 0%, transparent 70%);
                    pointer-events: none;
                }

                /* Image Column Styles */
                .image-wrapper {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .image-card {
                    position: relative;
                    width: 100%;
                    max-width: 420px;
                    margin: 0 auto;
                }

                .owner-image {
                    position: relative;
                    margin: 0;
                    border-radius: 30px;
                    overflow: hidden;
                    background: linear-gradient(135deg, #ff2222, #cc0000);
                    padding: 4px;
                    box-shadow: 0 30px 50px rgba(0,0,0,0.12);
                    transition: all 0.4s ease;
                }

                .owner-image:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 40px 60px rgba(255,34,34,0.25);
                }

                .owner-image img {
                    width: 100%;
                    height: auto;
                    border-radius: 28px;
                    display: block;
                    transition: transform 0.4s ease;
                }

                .owner-image:hover img {
                    transform: scale(1.03);
                }

                .image-overlay {
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    right: 20px;
                }

                .experience-badge {
                    display: inline-block;
                    background: linear-gradient(135deg, #ff2222, #cc0000);
                    color: white;
                    padding: 8px 20px;
                    border-radius: 40px;
                    font-size: 14px;
                    font-weight: 600;
                    box-shadow: 0 5px 15px rgba(255,34,34,0.3);
                    backdrop-filter: blur(10px);
                }

                .btn-meet {
                    display: inline-flex;
                    align-items: center;
                    gap: 12px;
                    background: var(--btn-meet-bg);
                    color: var(--btn-meet-color);
                    padding: 14px 32px;
                    border-radius: 50px;
                    font-weight: 600;
                    font-size: 16px;
                    text-decoration: none;
                    margin-top: 25px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    border: 2px solid var(--btn-meet-border);
                }

                .btn-meet:hover {
                    background: #ff2222;
                    color: white;
                    transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(255,34,34,0.3);
                    gap: 15px;
                    border-color: transparent;
                }

                .arrow-icon {
                    transition: transform 0.3s ease;
                }

                .btn-meet:hover .arrow-icon {
                    transform: translateX(5px);
                }

                /* Content Column Styles */
                .content-inner {
                    padding-left: 30px;
                }

                .section-badge {
                    display: inline-block;
                    background: rgba(255,34,34,0.1);
                    color: #ff2222;
                    padding: 6px 18px;
                    border-radius: 50px;
                    font-size: 14px;
                    font-weight: 600;
                    margin-bottom: 20px;
                    letter-spacing: 0.5px;
                }

                .founder-name {
                    font-size: 48px;
                    font-weight: 700;
                    color: var(--founder-name-color);
                    margin-bottom: 15px;
                    transition: color 0.3s ease;
                }

                .founder-name .highlight {
                    color: #ff2222;
                    position: relative;
                    display: inline-block;
                }

                .founder-name .highlight::after {
                    content: '';
                    position: absolute;
                    bottom: 5px;
                    left: 0;
                    right: 0;
                    height: 8px;
                    background: rgba(255,34,34,0.2);
                    border-radius: 4px;
                }

                .tagline {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: var(--tagline-bg);
                    color: var(--tagline-color);
                    padding: 8px 20px;
                    border-radius: 50px;
                    font-size: 14px;
                    font-weight: 500;
                    margin-bottom: 25px;
                    transition: all 0.3s ease;
                }

                .tagline-icon {
                    color: #ff2222;
                    font-size: 18px;
                }

                /* Social Links */
                .social-links {
                    display: flex;
                    gap: 12px;
                    margin-bottom: 30px;
                }

                .social-link {
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    font-size: 18px;
                    transition: all 0.3s ease;
                    text-decoration: none;
                }

                .social-link.fb {
                    background: rgba(24,119,242,0.1);
                    color: #1877f2;
                }
                .social-link.ig {
                    background: rgba(214,41,118,0.1);
                    color: #d62976;
                }
                .social-link.li {
                    background: rgba(0,119,181,0.1);
                    color: #0077b5;
                }
                .social-link.yt {
                    background: rgba(255,0,0,0.1);
                    color: #ff0000;
                }

                [data-theme="dark"] .social-link.fb {
                    background: rgba(24,119,242,0.2);
                }
                [data-theme="dark"] .social-link.ig {
                    background: rgba(214,41,118,0.2);
                }
                [data-theme="dark"] .social-link.li {
                    background: rgba(0,119,181,0.2);
                }
                [data-theme="dark"] .social-link.yt {
                    background: rgba(255,0,0,0.2);
                }

                .social-link:hover {
                    transform: translateY(-5px);
                }
                .social-link.fb:hover { background: #1877f2; color: white; }
                .social-link.ig:hover { background: linear-gradient(45deg, #f09433, #d62976, #962fbf); color: white; }
                .social-link.li:hover { background: #0077b5; color: white; }
                .social-link.yt:hover { background: #ff0000; color: white; }

                /* Description Text */
                .description-text p {
                    color: var(--description-text-color);
                    line-height: 1.8;
                    margin-bottom: 18px;
                    text-align: justify;
                    font-size: 15px;
                    transition: color 0.3s ease;
                }

                .description-text strong {
                    color: #ff2222;
                }

                /* Stats Grid */
                .stats-grid {
                    display: flex;
                    gap: 20px;
                    margin: 30px 0;
                    flex-wrap: wrap;
                }

                .stat-card {
                    flex: 1;
                    background: var(--stat-card-bg);
                    padding: 20px;
                    border-radius: 20px;
                    text-align: center;
                    box-shadow: 0 5px 20px var(--stat-card-shadow);
                    transition: all 0.3s ease;
                    border: 1px solid var(--stat-card-border);
                }

                .stat-card:hover {
                    transform: translateY(-5px);
                    border-color: #ff2222;
                    box-shadow: 0 15px 30px rgba(255,34,34,0.12);
                }

                .stat-number {
                    font-size: 36px;
                    font-weight: 800;
                    color: #ff2222;
                    margin-bottom: 8px;
                }

                .stat-number span {
                    font-size: 24px;
                }

                .stat-label {
                    font-size: 13px;
                    color: var(--stat-label-color);
                    font-weight: 500;
                    letter-spacing: 0.5px;
                    transition: color 0.3s ease;
                }

                /* Expertise Tags */
                .expertise-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .tag {
                    background: linear-gradient(135deg, #ff2222, #cc0000);
                    color: white;
                    padding: 8px 18px;
                    border-radius: 40px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.3s ease;
                    cursor: default;
                }

                .tag:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(255,34,34,0.3);
                }

                /* Dark mode additional enhancements */
                [data-theme="dark"] .owner-image {
                    box-shadow: 0 30px 50px rgba(0,0,0,0.3);
                }

                [data-theme="dark"] .owner-image:hover {
                    box-shadow: 0 40px 60px rgba(255,34,34,0.3);
                }

                [data-theme="dark"] .section-badge {
                    background: rgba(255,34,34,0.2);
                }

                [data-theme="dark"] .stat-card:hover {
                    box-shadow: 0 15px 30px rgba(255,34,34,0.2);
                }

                /* Responsive */
                @media (max-width: 992px) {
                    .content-inner {
                        padding-left: 0;
                        margin-top: 40px;
                        text-align: center;
                    }

                    .founder-name {
                        font-size: 36px;
                    }

                    .founder-name .highlight::after {
                        bottom: 0;
                    }

                    .social-links {
                        justify-content: center;
                    }

                    .stats-grid {
                        justify-content: center;
                    }

                    .stat-card {
                        min-width: 160px;
                    }

                    .expertise-tags {
                        justify-content: center;
                    }

                    .description-text p {
                        text-align: center;
                    }
                }

                @media (max-width: 576px) {
                    .about-section {
                        padding: 60px 0;
                    }

                    .founder-name {
                        font-size: 28px;
                    }

                    .stat-card {
                        min-width: 140px;
                        padding: 15px;
                    }

                    .stat-number {
                        font-size: 28px;
                    }
                }
            `}</style>
        </>
    );
};

export default AboutOwner;


